import React, { useEffect, useState } from 'react';
import { ContentContainer, SectionPage, Row, Col, ComponentLoader, Button, Checkbox, Heading, Card } from '@snsw-gel/react';
import { history } from '@starterapp/shared-services/history';
import { getLinkedCard, patchUpgrade } from '../../../services/api-services';
import selectedCardStyles from '../../ApplicationFlow/SelectedCard/SelectedCard.module.scss';
import styles from './UpgradeCard.module.scss';
import SCImage from '../../ApplicationFlow/SelectedCard/SC_1.jpg';
import { dataLayer } from '../../../services/gtm-dataLayer';

const UpgradeCardPage = () => {
    const [hasConfirmed, setHasConfirmed] = useState(false);
    const [hasDeclared, setHasDeclared] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);

    useEffect(() => {
        const currentUrl = window.location.href;
        const pageName = window.location.href.split('/').pop();
        dataLayer(currentUrl, pageName);
    }, []);

    const onSubmitUpgrade = () => async _ => {
        setShowSpinner(true);

        let response;
        try {
            response = await patchUpgrade();
        } catch (ex) { }

        setShowSpinner(false);

        if (!response._httpStatus || response._httpStatus === 200) {
            sessionStorage.setItem('CardTypeText', 'Seniors Card');
            sessionStorage.setItem('ConfirmationResponse', 'upgrade');
            history.push('/changeDetailsConfirmation');
            window.dispatchEvent(new PopStateEvent('popstate'));
        } else {
            history.push('/applicationError');
            window.dispatchEvent(new PopStateEvent('popstate'));
        }
    };

    return (
        <>
            <ContentContainer>
                <Row>
                    <Col span={12}>
                        <SectionPage>
                            <Heading level={1}>Convert your NSW Senior Savers Card to a NSW Seniors Card</Heading>
                            <Heading level={3}>If you work 20 hours or less of paid work per week, you are eligible for a Seniors Card</Heading>
                            <Checkbox
                                id='hours'
                                name='hours'
                                label='I confirm that I work 20 hours or less of paid work per week, on average across a 12 month period'
                                value='hours'
                                errorMessage='Please confirm that you work 20 hours or less per week'
                                testId='hours'
                                onChange={(value) => setHasConfirmed(Boolean(value))}
                                checked={hasConfirmed}
                                isRequired
                            />
                            <Checkbox
                                id='declare'
                                name='declare'
                                label='I declare that I have understood the questions and I have provided information that is truthful and complete. I understand that it is an offence to provide false and misleading information in my Seniors Card application.'
                                value='declare'
                                errorMessage='Please declare that your provided information is true and complete'
                                testId='declare'
                                onChange={(value) => setHasDeclared(Boolean(value))}
                                checked={hasDeclared}
                                isRequired
                            />
                        </SectionPage>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Card
                            height='100%'
                            className={`${selectedCardStyles['card-display']} ${selectedCardStyles.selected}`}
                        >
                            <div className={selectedCardStyles['card-content']}>
                                <div className={selectedCardStyles['card-example-image']}>
                                    <img src={SCImage} alt='Example Seniors Card' />
                                </div>
                                <ul>
                                    <li>Eligible if you are working 20 hours or less of paid work per week, on average across a 12 month period</li>
                                    <li>Discounts from a wide range of businesses</li>
                                    <li>Eligible to apply for a Gold Opal card and the NSW National Parks Annual Pass discount</li>
                                </ul>
                            </div>
                            {/* <p className={selectedCardStyles['card-switching-notice']}>* If your working conditions change, you are able to switch to Seniors Card by calling 13 77 88.</p> */}
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <div className={styles['button-panel']}>
                            <Button
                                className={`${styles['convert-button']} button-item`}
                                id='applyButton'
                                disabled={!hasConfirmed || !hasDeclared}
                                onClick={onSubmitUpgrade()}
                            >
                                Convert my card
                            </Button>
                            <Button
                                className={`${styles['dashboard-button']} dashboard-button`}
                                variant="secondary"
                                href={process.env.REACT_APP_SENIORS_DASHBOARD_URL}
                            >
                                Back to dashboard
                            </Button>
                        </div>
                    </Col>
                </Row>
            </ContentContainer>
            {
                showSpinner && (<ComponentLoader fullPage />)
            }
        </>
    );
};

export default UpgradeCardPage;
